import { QuoteFormState } from "./useQuoteFormSelector";
import dealerRoles from "../../util/dealerAccounts";

function findRequiredState(state: QuoteFormState, signInRole: string) {
  const reqs: string[] = [];
  if (!state.jobName) reqs.push("Project Name");
  if (!state.customerName && dealerRoles.includes(signInRole))
    reqs.push("Customer Name");
  if (!state.agSalesperson) reqs.push("AG Sales Rep");
  if (!state.dealer) reqs.push("Dealer");
  if (!state.salesperson) reqs.push("Dealer Rep Name");
  if (!state.email) reqs.push("Dealer Rep Email");
  if (!state.checkedDealer && !state.checkedJobsite) reqs.push("Ship To");
  if (state.checkedDealer) {
    if (!state.address) reqs.push("Address");
    if (!state.city) reqs.push("City");
    if (!state.zip) reqs.push("Zip Code");
  }

  if (state.customerZip && !state.customerCity) reqs.push("Jobsite City");
  if (!state.customerZip && state.customerCity) reqs.push("Jobsite Zip Code");

  return reqs;
}

export { findRequiredState };
